module.exports = __webpack_public_path__ + "static/homeVentGood-4c417a3ff92e659ed4368244efea4f9a.gif";